import {useParams} from 'react-router-dom';
import mainStyles from '../../../components/main/main.module.scss';
import {Main} from '../../../components/main/main.tsx';
import styles from './occasion_modal.module.scss';
import {FlexRow} from '../../../components/utility/flex_row.tsx';
import {FlexColumn} from '../../../components/utility/flex_column.tsx';
import {Alignment} from '../../../enums/alignment.ts';
import {Button} from '../../../components/button/button.tsx';
import {ButtonPosition} from '../../../enums/button_position.ts';
import {__, transString} from '../../../support/lang/translations.ts';
import {Page} from '../../../components/page/page.tsx';
import {PageContent} from '../../../components/page/page_content.tsx';
import {useAppSelector} from '../../../store/store.ts';
import {PageTitle} from '../../../components/page/page_title.tsx';

export function LeadSuccessForm() {
    const appConfig = useAppSelector((state) => state.appConfig.appconfig);
    const {occasionId, leadType} = useParams();
    const translatedLeadType = transString(`occasions.details.leads.types.${leadType}`);

    if (!appConfig || !appConfig.appname || !occasionId) {
        return null;
    }

    return (
        <Main className={mainStyles.bg_white}>
            <div className={styles.occasion_modal}>
                <nav className={styles.occasion_modal__nav}>
                    <div className={styles.title__buttons}>
                        <FlexRow>
                            <FlexColumn alignment={Alignment.Start}>
                                <Button
                                    to={`/occasion/${occasionId}`}
                                    position={ButtonPosition.Right}
                                    noBorder={true}
                                    preventScrollReset={true}
                                >
                                    <i className="fa-light fa-chevron-left" />
                                    {__('occasions.details.buttons.back_to_occasion')}
                                </Button>
                            </FlexColumn>
                        </FlexRow>
                    </div>
                </nav>
                <Page>
                    <PageTitle>
                        <h1>{__('occasions.details.leads.thank_you.title', {type: translatedLeadType})}</h1>
                    </PageTitle>
                    <PageContent>
                        <FlexRow alignment={Alignment.Center}>
                            <FlexColumn alignment={Alignment.Center}>
                                <p style={{textAlign: 'center'}}>
                                    {__('occasions.details.leads.thank_you.body', {name: appConfig.appname})}
                                </p>
                            </FlexColumn>
                        </FlexRow>
                    </PageContent>
                </Page>
            </div>
        </Main>
    );
}
